import { ProgressBar as BootstrapProgressBar } from 'react-bootstrap';

const ProgressBar = ({ displayText, value }) => (
  <div className="position-relative">
    <BootstrapProgressBar
      now={value}
      min={0}
      max={100}
      style={{
        padding: '0px',
        height: '16px',
        background: 'linear-gradient(50deg, var(--bs-dark) 0%, var(--bs-gray-800) 100%)',
        borderRadius: '8px',
      }}
      variant={value >= 100 ? 'success' : 'info'}
    />
    <div
      className=""
      style={{ left: 0, right: 0 }}
    >
      <small>{displayText}</small>
    </div>
  </div>
);

export default ProgressBar;
